<template>
    <div class="banner" >
        <swiper ref="mySwiper" :options="swiperOptions">
          <swiper-slide v-for="(item, index) in banners" :key="index"><img :src="item.img"/></swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
        <template v-if="banners && false">
          <el-carousel height="240px">
            <el-carousel-item v-for="(item, index) in banners" :key="index">
              <img :src="item.img"/>
            </el-carousel-item>
          </el-carousel>
        </template>
      </div>
</template>

<script>
import {picList} from '@/api/server/pic'

import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.min.css'
import Swiper2, {Autoplay} from 'swiper';

Swiper2.use([Autoplay]);

export default {
  name: 'BannerComponent',
  data () {
    return {
        banners: null,
        swiperOptions: {
            // effect: 'fade',
            observer:true,//修改swiper⾃⼰或⼦元素时，⾃动初始化swiper 
            observeParents:true,//修改swiper的⽗元素时，⾃动初始化swiper 
            loop:true,
            speed:2000, //动画时间
            autoplay: {
            delay:5000, //等待时间
            stopOnLastSlide: true,
            },
            pagination: {
            el: '.swiper-pagination'
            },
            // Some Swiper option/callback...
        },
    }
  },
  components: {
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  computed: {
      swiper() {
       return this.$refs.mySwiper.$swiper
      },
  },
  methods: {
    _getPics () {
      let query = {
        cid: 1
      }
      picList(query).then( (res) => {
        if (res.code === 200) {
          this.banners = res.data
        }
      })
    },
  },
  mounted: function () {
    this._getPics()
    this.swiper.slideTo(1, 1000, false)
  }

}
</script>
<style lang="scss" scoped>
</style>
